import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'shared-routing';
import { useTranslations } from '@lang';
import { Routes } from '@common/constants';
import { Button } from '@common/components';
import { ProductGrid } from '@common/components/ProductGrid';
import { FeaturedProductsWrapper, FeaturedTitle } from '@routes/Home/components/Featured.styles';
import { useLabels } from '@common/features/Menu/useLabels';

const FeaturedProducts = ({ propertyName, products }) => {
  const { t } = useTranslations();
  const labels = useLabels();

  return (
    <FeaturedProductsWrapper>
      <FeaturedTitle>{labels?.retail || t('category.shop', { propertyName })}</FeaturedTitle>
      <ProductGrid items={products.slice(0, 8)} />
      <Link route={Routes.PRODUCT_LIST}>
        <Button>{t('home.showAllProducts')}</Button>
      </Link>
    </FeaturedProductsWrapper>
  );
};

FeaturedProducts.propTypes = {
  propertyName: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default FeaturedProducts;
